import { DateTime } from "luxon";

export function formatDate(date: string, format = 'dd LLL yyyy') {
    return DateTime.fromISO(date).toFormat(format);
}
export function includesOneOf(arr: string[], checking: string[]) {
    return !!checking.find(p => arr.includes(p));
}